/**
 * @file: formatLeadCardTime.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * Time helpers for the lead card. Recent days collapse to 今日/昨日 so the most
 * common rows read at a glance; older rows fall back to the absolute date.
 */

import { dateFromValue } from '@euler/utils/datetime';
import format from 'date-fns/format';
import isToday from 'date-fns/isToday';
import isYesterday from 'date-fns/isYesterday';

/** Card header timestamp (lead creation): 今日 / 昨日 / MM-dd, plus HH:mm. */
export const formatLeadCreatedTime = (
  value: string | Date | undefined | null,
): string => {
  if (!value) return '';
  try {
    const d = dateFromValue(value);
    const time = format(d, 'HH:mm');
    if (isToday(d)) return `今日 ${time}`;
    if (isYesterday(d)) return `昨日 ${time}`;
    return format(d, 'MM-dd HH:mm');
  } catch {
    return '';
  }
};

/** Absolute MM-dd HH:mm, used for the last-reach timestamp. */
export const formatLeadReachTime = (
  value: string | Date | undefined | null,
): string => {
  if (!value) return '';
  try {
    return format(dateFromValue(value), 'MM-dd HH:mm');
  } catch {
    return '';
  }
};

/** Plain yyyy-MM-dd for the target-service-date field (— when empty). */
export const formatLeadDate = (
  value: string | Date | undefined | null,
): string => {
  if (!value) return '—';
  try {
    return format(dateFromValue(value), 'yyyy-MM-dd');
  } catch {
    return '—';
  }
};
